import { useContext, useState } from "react";
import { eCONFIGURATION, ePrivileges } from "../../../utils/enum";

import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./configuration.module.css";

import StateConfigurationList1 from "../config-state/list";
// import ConfigGroupList1 from "../config-group/list";
// import ConfigParamList1 from "../config-param/list";
import StatusReasonList1 from "../status-reasons/list";
import ConfigCategoryList from "../config-category/list";
import ConfigSpareList from "../config-spare/list";
import ConfigProductList from "../config-product/list";
import HolidayList from "../holidays/list";
import ProductRateList from "../product-rate/list";

function ConfigurationList() {
  const context: any = useContext(UserContext);
  const [activeConfig, setActiveConfig] = useState<string>("");

  // Mapping of configuration types to privileges
  const configPrivilegeMap = {
    // [eCONFIGURATION.CONFIGGROUP]: ePrivileges.VIEWCONFIGGROUP,
    // [eCONFIGURATION.CONFIGPARAM]: ePrivileges.VIEWCONFIGPARAM,
    [eCONFIGURATION.STATUSREASON]: ePrivileges.VIEWSTATUSREASON,
    [eCONFIGURATION.STATECONFIGURATION]: ePrivileges.VIEWSTATECONFIGRATION,
    [eCONFIGURATION.CONFIGCATEGORY]: ePrivileges.VIEWCONFIGCATEGORY,
    [eCONFIGURATION.CONFIGSPARE]: ePrivileges.VIEWCONFIGSPARE,
    [eCONFIGURATION.CONFIGPRODUCT]: ePrivileges.VIEWCONFIGPRODUCT,
    [eCONFIGURATION.PROJECTCALENDAR]: ePrivileges.VIEWCALENTRY,
    [eCONFIGURATION.PRODUCTRATE]: ePrivileges.VIEWPRODUCTRATE,
  };

  // Mapping of configuration types to display names
  const configDisplayNames: Record<eCONFIGURATION, string> = {
    // DISABLED THE CONFIG GROUP AND CONFIG PARAM TAB IN CONFIGURATION -->> IF NEED TO ENABLE, ALSO REQUIRED CHANGES IN TYPE eCONFIGURATION
    // [eCONFIGURATION.CONFIGGROUP]: "Config Group",
    // [eCONFIGURATION.CONFIGPARAM]: "Config Param",
    [eCONFIGURATION.STATUSREASON]: "Status Reason",
    [eCONFIGURATION.STATECONFIGURATION]: "State Configuration",
    [eCONFIGURATION.CONFIGCATEGORY]: "Ticket Issue Category",
    [eCONFIGURATION.CONFIGSPARE]: "Config Spare",
    [eCONFIGURATION.CONFIGPRODUCT]: "Config Product",
    [eCONFIGURATION.PROJECTCALENDAR]: "Project Calendar",
    [eCONFIGURATION.PRODUCTRATE]: "Product Rate",
  };

  // Filter configurations based on user privileges
  const accessibleConfigurations = Object.entries(configPrivilegeMap).filter(
    ([_, privilege]) =>
      Utils.isUserHasAccess(context.user?.privilegeList, privilege)
  );

  // Automatically set the first accessible configuration as active
  if (!activeConfig && accessibleConfigurations.length > 0) {
    setActiveConfig(accessibleConfigurations[0][0]); // First accessible configuration
  }

  const clearQueryParams = () => {
    const baseUrl = window.location.origin + window.location.pathname;
    window.history.replaceState(null, "", baseUrl); // Replace URL without query params
  };

  return (
    <div>
      <div className={styles.parentContainer}>
        {accessibleConfigurations.map(([configType]) => (
          <div
            key={configType}
            className={`${styles.tab} ${
              activeConfig === configType ? styles.activeTab : ""
            }`}
            onClick={() => {
              clearQueryParams();
              setActiveConfig(configType);
            }}
          >
            <span
              className={
                activeConfig === configType
                  ? styles.activeText
                  : styles.inactiveText
              }
            >
              {configDisplayNames[configType as eCONFIGURATION]}{" "}
              {/* Explicit display name */}
            </span>
          </div>
        ))}
      </div>
      {/* IF NEED CONFIG GROUP OR CONFIG PARAM TAB :: UNCOMMENT THE BELOW AND MOVE INSIDE THE BELOW DIV */}
      {/* {activeConfig === eCONFIGURATION.CONFIGGROUP && <ConfigGroupList1 />}
      {activeConfig === eCONFIGURATION.CONFIGPARAM && <ConfigParamList1 />} */}
      <div>
        {activeConfig === eCONFIGURATION.STATUSREASON && <StatusReasonList1 />}
        {activeConfig === eCONFIGURATION.STATECONFIGURATION && (
          <StateConfigurationList1 />
        )}
        {activeConfig === eCONFIGURATION.CONFIGCATEGORY && (
          <ConfigCategoryList />
        )}
        {activeConfig === eCONFIGURATION.CONFIGSPARE && <ConfigSpareList />}
        {activeConfig === eCONFIGURATION.CONFIGPRODUCT && <ConfigProductList />}
        {activeConfig === eCONFIGURATION.PROJECTCALENDAR && <HolidayList />}
        {activeConfig === eCONFIGURATION.PRODUCTRATE && <ProductRateList />}
      </div>
    </div>
  );
}

export default ConfigurationList;
